import React, { FC } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import styled from 'styled-components';

import Checkbox from '@/components/Checkbox';
import { Larger } from '@/components/Forms';
import Text from '@/components/Text';
import useAlerts from '@/hooks/useAlerts';

const StyledText = styled(Text)`
  span {
    font-weight: 400;
  }
`;

interface Props {
  isGpm: boolean;
  setValue: UseFormSetValue<any>;
}

const GpmCheckboxFiekd: FC<Props> = ({ isGpm, setValue }) => {
  const alerts = useAlerts();

  const onChange = async () => {
    if (isGpm) return setValue('gpm', false);

    const confirmed = await alerts.confirm(
      'Are you sure you want to exclude 15% of the amount for taxes?',
    );

    if (confirmed) setValue('gpm', true);

    return alerts.close();
  };

  return (
    <Larger>
      <Checkbox checked={!!isGpm} onChange={onChange}>
        <StyledText $type="smallHeadline">
          15% of the amount has been excluded for taxes <span>(GPM)</span>
        </StyledText>
      </Checkbox>
    </Larger>
  );
};

export default GpmCheckboxFiekd;
